import * as constants from '../constants'

export const setIsUserAuthenticated = (setIsUserAuthenticated) => {
  return {
    type: constants.SET_IS_USER_AUTHENTICATED,
    isUserAuthenticated: setIsUserAuthenticated,
  }
}

export const setRoutes = (routes) => {
  return {
    type: constants.SET_ROUTES,
    routes: routes,
  }
}
